<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import { add, getSwitch, getDetails, update, del } from "@/api/tracker/switch";
import { getCities } from "@/api/tracker/cities";
import { getClients } from "@/api/tracker/clients";
// import { add, getStatus, getDetails, update, del } from "@/api/tracker/status";
import cTable from "@/base/common/index";
export default {
  name: "trackerSwitch",
  components: {
    cTable
  },

  async mounted() {},
  methods: {},
  data() {
    let servicetypeList = [
      {
        label: "NCND"
      },
      {
        label: "NOR"
      },
      {
        label: "ALL"
      }
    ];
    let typeList = [
      {
        label: "GT"
      },
      {
        label: "GTE"
      },
      {
        label: "LT"
      },
      {
        label: "LTE"
      }
    ];
    return {
      methods: {
        list: getSwitch,
        add,
        getDetails,
        update,
        del,
        getCities,
        getClients
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods(row.id ? "update" : "add", row, true)
                .then(e => {
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: "40%"
            },
            formBind: {
              labelWidth: 150
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              from_channel: [
                {
                  required: true,
                  type: "string",
                  message: "from_channel cannot be empty",
                  trigger: "blur"
                },
                {
                  min: 4,
                  max: 5,
                  message: "Please Minimum length 4 and maximum length 5",
                  trigger: "blur"
                }
              ],
              target_channel: [
                {
                  required: true,
                  message: "target_channel cannot be empty",
                  trigger: "blur"
                },
                {
                  min: 4,
                  max: 5,
                  message: "Please Minimum length 4 and maximum length 5",
                  trigger: "blur"
                }
              ],
              match_city_id: [
                {
                  required: true,
                  type: "number",
                  message: "match_city_id cannot be empty",
                  trigger: "change"
                }
              ],
              match_client_id: [
                {
                  required: true,
                  type: "number",
                  message: "match_client_id cannot be empty",
                  trigger: "change"
                }
              ],
              match_service_type: [
                {
                  required: true,
                  type: "string",
                  message: "match_service_type cannot be empty",
                  trigger: "change"
                }
              ],
              match_cod_operator: [
                {
                  required: true,
                  type: "string",
                  message: "match_cod_operator cannot be empty",
                  trigger: "change"
                }
              ],
              match_cod_amount: [
                {
                  type: "number",
                  required: true,
                  trigger: "blur"
                }
              ],
              match_values_operator: [
                {
                  required: true,
                  type: "string",
                  message: "match_values_operator cannot be empty",
                  trigger: "change"
                }
              ],
              match_values_amount: [
                {
                  type: "number",
                  required: true,
                  trigger: "blur"
                }
              ],
              sort: [
                {
                  type: "number",
                  required: true,
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [
            { from_channel: 24 },
            { target_channel: 24 },
            { match_city_id: 24 },
            { match_client_id: 24 },
            { match_service_type: 24 },
            { match_cod_operator: 24 },
            { match_cod_amount: 24 },
            { match_values_operator: 24 },
            { match_values_amount: 24 },
            { sort: 24 }
          ],
          fields: [
            {
              key: "from_channel",
              name: () => this.$t("from_channel"),
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("from_channel")
            },
            {
              key: "target_channel",
              name: () => this.$t("target_channel"),
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("target_channel")
            },
            {
              key: "match_city_id",
              name: () => this.$t("match_city"),
              component: "Select",
              config: {
                label: "group_name",
                value: "id"
              },
              placeholder: () => this.$t("select") + this.$t("match_city"),
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCities")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "match_client_id",
              name: () => this.$t("match_client"),
              component: "Select",
              config: {
                label: "group_name",
                value: "id"
              },
              placeholder: () => this.$t("select") + this.$t("match_client"),
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getClients")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "match_service_type",
              name: () => this.$t("match_service_type"),
              component: "Select",
              config: {
                label: "label",
                value: "label"
              },
              placeholder: () =>
                this.$t("select") + this.$t("match_service_type"),
              options: servicetypeList
            },
            {
              key: "match_cod_operator",
              name: () => this.$t("match_cod_operator"),
              component: "Select",
              config: {
                label: "label",
                value: "label"
              },
              placeholder: () =>
                this.$t("select") + this.$t("match_cod_operator"),
              options: typeList
            },
            {
              key: "match_cod_amount",
              name: () => this.$t("match_cod_amount"),
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("match_cod_amount"),
              bind: {
                step: 0.01,
                min: 0,
                style: "width:100%"
              },
              default: 0
            },
            {
              key: "match_values_operator",
              name: () => this.$t("match_values_operator"),
              component: "Select",
              config: {
                label: "label",
                value: "label"
              },
              placeholder: () =>
                this.$t("select") + this.$t("match_values_operator"),
              options: typeList
            },
            {
              key: "match_values_amount",
              name: () => this.$t("match_values_amount"),
              component: "InputNumber",
              placeholder: () =>
                this.$t("enter") + this.$t("match_values_amount"),
              bind: {
                step: 0.01,
                min: 0,
                style: "width:100%"
              },
              default: 0
            },
            {
              key: "sort",
              name: () => this.$t("sort"),
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("sort"),
              bind: {
                step: 1,
                min: 0,
                style: "width:100%"
              },
              default: 0
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "matchServiceType",
            placeholder() {
              return this.$t("select") + this.$t("type");
            },
            component: "Select",
            options: servicetypeList,
            config: {
              label: "label",
              value: "label"
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              bind: {
                type: "warning",
                icon: "md-add"
              },
              id: 174
            }
          ],
          methods: {
            addFun({ field, searchForm }) {
              this.getModal("add").open({}, function() {
                this.setTitle(this.$t("add"));
              });
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$t("from_channel"),
          key: "from_channel",
          align: "center",
          minWidth: 120
        },
        {
          name: () => this.$t("target_channel"),
          key: "target_channel",
          align: "center",
          minWidth: 110
        },
        {
          name: () => this.$t("match_city"),
          key: "city_group_name",
          align: "left",
          minWidth: 110,
          methods: {
            render({ row }) {
              return row.cityGroup ? row.cityGroup.group_name : "/";
            }
          }
        },
        {
          name: () => this.$t("match_client"),
          key: "client_group_name",
          align: "left",
          minWidth: 110,
          methods: {
            render({ row }) {
              return row.clientGroup ? row.clientGroup.group_name : "/";
            }
          }
        },
        {
          name: () => this.$t("match_service_type"),
          key: "match_service_type",
          align: "center",
          minWidth: 120
        },
        {
          name: () => this.$t("match_cod_operator"),
          key: "match_cod_operator",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("match_values_operator"),
          key: "match_values_operator",
          align: "center",
          minWidth: 150
        },
        {
          name: () => this.$t("match_cod_amount"),
          key: "match_cod_amount",
          align: "center",
          minWidth: 120
        },
        {
          name: () => this.$t("match_values_amount"),
          key: "match_values_amount",
          align: "center",
          minWidth: 150
        },
        {
          name: () => this.$t("sort"),
          key: "sort",
          align: "center",
          minWidth: 90
        },
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success"
              },
              id: 175
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error"
              },
              id: 176
            }
          ],

          methods: {
            async updateFun({ row }) {
              console.log(row);
              let res = await this.handleRequestMethods("getDetails", {
                id: row.id
              });
              console.log("res", res);

              this.getModal("add").open(res.payload, function() {
                console.log(this);
                this.setTitle(this.$t("update"));
              });
            },
            async operationFun({ row }) {
              this.getModal("operation").open(
                {
                  packageId: row.id
                },
                function() {
                  this.setTitle(this.$t("operation"));
                }
              );
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  this.$t("target_channel") +
                  ":" +
                  row.target_channel +
                  "?",
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    {
                      id: row.id
                    },
                    true
                  ).then(res => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
